export interface Position {
  id: number;
  position: number;
}

export enum APIFileStatus {
  OK = 'ok',
  ERROR = 'error',
  ANONYMIZATION_ERROR = 'anonymization_error',
  PENDING = 'pending',
}

export type APIFileStatusValues = `${APIFileStatus}` | null;
